module.exports = __webpack_public_path__ + "img/avatar_sprite.968f335f.png";